const ENVIRONMENT = window.__ENVIRONMENT__ || __ENVIRONMENT__;
export const isProduction = ENVIRONMENT === "prod";
